
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Boxplot/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["boxplot-demo-common","boxplot-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Boxplot__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Boxplot/index.en.md?type=demo')
};